import { useDownloadsContext } from './use-downloads-context'
import { CategoryNames } from '../dto'
import { getCurrentLanguage } from 'src/Libs/languages/functions/default'
import { useCallback } from 'react'

export const useCategoryDisplayName = (): ((names: CategoryNames) => string) => {
  const { languageFilter } = useDownloadsContext()
  const appLanguage = getCurrentLanguage()
  const languageToDisplay = languageFilter === 'all' ? appLanguage : languageFilter

  return useCallback(
    (names: CategoryNames) => {
      return names[languageToDisplay]
    },
    [languageToDisplay]
  )
}
